// src/app/page.js
"use client"; // Client directive for using hooks

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Hero from './Hero';
import Technology from './Technology';
import CompatibleDevices from './CompatibleDevices';
import Footer from './Footer';

const Home = () => {

  return (
    <>
        <Header/>
        <Hero/>
        <Technology />
        <CompatibleDevices />
        <Footer />
    </>
  );
};

export default Home;
